<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" v-if="isIndex()">
        <div class="row">
          <div class="col-md">
            <div class="form-group has-label">
              <label>{{ $t('common_words.request_type') }}</label>
              <el-select
                id="typeRequest"
                class="select-primary custom-width-select bus-rels shadow-sm"
                v-model="typeRequest"
                filterable
              >
                <el-option
                  v-for="option in typeRequests"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md">
            <l-button
              wide
              type="primary"
              class="btn-filter shadow-sm"
              style="margin-top: 30px"
              @click="send"
            >{{ $t('common_words.send') }}</l-button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <json-viewer :value="data"></json-viewer>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
export default {
  mixins: [MixinPermissions, mixinMasters],
  data() {
    return {
      typeRequest: 1,
      typeRequests: [
        { id: 1, name: 'SmartCultivo' },
        { id: 2, name: 'MeteoApp' }
      ],
      data: []
    };
  },
  methods: {
    send() {
      this.data = [];
      let url = '';
      if (this.typeRequest == 1) {
        url = 'irrigation/notification/sendEmail/America-Bogota';
      } else {
        url = 'irrigation/meteoappnotification/sendEmail/America-Bogota';
      }
      Axios.getMasters(url)
        .then(response => {
          this.data = response.data;
          SweetAlert.success(response.data.message);
        })
        .catch(error => {
          SweetAlert.warning(error.response.data.message);
        });
    }
  }
};
</script>
